// extracted by mini-css-extract-plugin
module.exports = {"socialMediaButtonGroup":"SocialMediaButtons__socialMediaButtonGroup___1Tuat","socialMediaImg":"SocialMediaButtons__socialMediaImg___1PaGw"};